import React from "react";
import PropTypes from "prop-types";
import Section from "../Section/Section";
import { bem } from "../../helpers";
import "./Form.scss";
import List from "../List/List";
import BaseField from "../Field/Base";
import FieldGroup from "../Field/Group";
import Input from "../Input/Input";

export class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: { ...props.defaultFormData }, //required values for resetting form
      formErrors: {},
    };
  }

  hasErrors = () => Object.keys(this.state.formErrors).length > 0;

  // change
  // - update state
  // - validate the input
  setValue = (newValuesObj, inputCB) => {
    let formData = { ...this.state.formData, ...newValuesObj };

    let newState = {
      formData,
    };

    //validation
    // newState.formErrors = this field's validation function

    this.setState(newState, () => {
      if (inputCB) {
        inputCB(newState);
      }

      if (this.props.onChange) {
        this.props.onChange(newState.formData);
      }
    });
  };

  // submit
  // - validate all inputs
  // - fire a callback
  //   - success
  //   - error
  validate = () => {
    console.log("validate");
    const formErrors = {};
    if (this.props.config?.validation) {
      const ids = Object.keys(this.props.config.validation);
      ids.map((id) => {
        const errors =
          this.props.config.validation && this.props.config.validation[id]
            ? this.props.config.validation[id](
                this.state.formData[id],
                this.state.formData,
                this.props.formProps
              )
            : [];

        if (errors && errors.length) {
          formErrors[id] = errors;
        }
      });
    }

    if (Object.keys(formErrors).length === 0) {
      this.setState({ formErrors }, (newState) => {
        this.onSuccess(this.state.formData);
      });
    } else {
      this.setState({ formErrors }, (newState) => {
        this.onError(this.state.formErrors, this.state.formData);
      });
    }
  };

  onSuccess = (formData) => {
    if (this.props.onSuccess) {
      var formRef = this;
      this.props.onSuccess(formData, formRef);
    }
  };

  onError = (formErrors, formData) => {
    if (this.props.onError) {
      this.props.onError(formErrors, formData, this);
    }
  };

  renderSections(sections, props) {
    return sections.map((section, sectionIndex) => {
      return (
        <Section
          key={sectionIndex}
          orientation={section.orientation ? section.orientation : "horizontal"}
          numItemsWide={section.numItemsWide}
          numItemsHigh={section.numItemsHigh}
          title={section.title}
          className={bem("form", "section", [], section.className)}
        >
          {section.fields && this.renderFields(section.fields, props)}
          {section.sections && this.renderSections(section.sections, props)}
        </Section>
      );
    });
  }

  renderFields = (fields, props) => {
    const { formProps, errorMode, config } = props;

    return fields.map((field) => {
      return field({
        key: field.id,
        formData: this.state.formData,
        formErrors: this.state.formErrors,
        onChange: this.setValue,
        submit: this.validate,
        formProps,
        className: bem("form", "field", [], field.className),
        displayErrors: errorMode === "field",
      });
    });
  };

  renderErrors = () => {
    if (this.hasErrors() && this.props.errorMode === "form") {
      return (
        <List
          className={bem("form", "errors", [], "errors")}
          listType="none"
          data={[].concat.apply([], Object.values(this.state.formErrors))}
        />
      );
    }
  };

  autoValidate = (fn) => {
    setTimeout(() => {
      fn(this);
    }, 500);
  };

  decorateChildren = (children, props) => {
    const { formProps, errorMode } = props;

    if (!Array.isArray(children)) {
      console.log("CHILDREN", "not array");
      return children;
    }
    return children.map((child) => {
      console.log(
        "CHILD",
        child.props.id,
        child.type.prototype instanceof FieldGroup && "FieldGroup",
        child.type.prototype instanceof BaseField && "BaseField",
        child.type.prototype instanceof Input && "Input"
      );

      let propsForFields = {
        ...child.props,
        key: child.props.id,
        formData: this.state.formData,
        formErrors: this.state.formErrors,
        onChange: (e, cb) => {
          this.setValue(e, cb);
          this.autoValidate((form) => {
            if (child.props.validate) {
              const fieldErrors = child.props.validate(
                form.state.formData[child.props.id],
                form.state.formData,
                form.formProps
              );
              form.setState({
                formErrors: {
                  ...form.state.formErrors,
                  "field-text": fieldErrors,
                },
              });
            }
          });
        },
        submit: () => {
          if (child.props.validate) {
            child.props.validate(
              this.state.formData[child.props.id],
              this.state.formData,
              this.formProps
            );
          }
          this.validate();
        },

        save: PropTypes.func,
        delete: PropTypes.func,
        read: PropTypes.func,
        reset: PropTypes.func,

        formProps,
        className: bem("form", "field", [], child.props.className),
        displayErrors: errorMode === "field",
      };

      if (child.type.prototype instanceof FieldGroup) {
        return {
          ...child,
          props: {
            ...child.props,
            propsForFields: propsForFields,
          },
        };
      } else if (
        child.type.prototype instanceof BaseField ||
        child.type.prototype instanceof Input
      ) {
        return {
          ...child,
          props: propsForFields,
        };
      } else if (child.type.prototype instanceof Section) {
        child.children = decorateChildren(child.children, props);
        return {
          ...child,
          props: propsForFields,
        };
      }

      return child;
    });
  };

  reset = (e) => {
    if (this.props.onReset) {
      this.props.onReset(e);
    } else {
      e?.preventDefault && e.preventDefault();
      this.setState({
        formData: { ...this.props.defaultFormData },
        formErrors: {},
      });
    }
  };

  submit = (e) => {
    if (this.props.onSubmit) {
      this.props.onSubmit(e);
    } else {
      e?.preventDefault && e.preventDefault();
      this.validate();
    }
  };

  render() {
    const { config, className, children, formProps, errorMode, debug } =
      this.props;

    return (
      <div className={bem("form", "", [], className)}>
        {this.renderErrors()}
        <form
          className={bem("form", "body")}
          onReset={this.reset}
          onSubmit={this.submit}
        >
          {config && (
            <Section
              orientation={config.orientation}
              numItemsWide={config.numItemsWide}
              numItemsHigh={config.numItemsHigh}
              gap={!!config.gap}
              title={config.title}
            >
              {config.fields && this.renderFields(config.fields, this.props)}
              {config.sections &&
                this.renderSections(config.sections, this.props)}
            </Section>
          )}
          {this.decorateChildren(children, this.props)}
        </form>

        {(debug || config?.debug) && (
          <table className={bem("form", "debug")}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody className={bem("form", "inputs")}>
              {Object.entries(this.state.formData).map(([name, value], i) => (
                <tr key={i}>
                  <td className={bem("form", "name")}>{name}</td>
                  <td className={bem("form", "value")}>
                    {this.getDebugValue(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }

  getDebugValue = (val) => {
    if (typeof val != "undefined" && val !== null) {
      if (typeof val === "object") {
        return JSON.stringify(val);
      } else {
        return val.toString ? val.toString() : val;
      }
    }
  };
}

Form.propTypes = {
  config: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  defaultFormData: PropTypes.object,
  debug: PropTypes.bool,
  save: PropTypes.func,
  delete: PropTypes.func,
  read: PropTypes.func,
  reset: PropTypes.func,
  errorMode: PropTypes.oneOf(["field", "form", "none"]),
};

Form.defaultProps = {
  defaultFormData: {},
  errorMode: "field",
  debug: false,
};

export default Form;
